<template>
    <layout :show_footer="false" :grow_body="!is_fetched">
        <template v-if="isCiaEnabled">
            <a-breadcrumb class="ml-4 mb-4">
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    <a @click="$router.go(-1)">
                        <template>
                            {{ $t('globals.navigation.header.cia_view.alt_title') }}
                        </template>
                    </a>
                </a-breadcrumb-item>
                <a-breadcrumb-item data-cy="breadcrumb-main">
                    {{ $t('covers.forms.title.cover_info') }}
                </a-breadcrumb-item>
            </a-breadcrumb>

            <form-renew-cover
                v-if="!is_fetched"
                :data="data"
                @select_policy="showModal"
                @cancel="onCancel"
                @formSubmit="onPolicySelect"
                ref="RenewForm"
            />

            <form-cover
                v-if="is_fetched"
                data-cy="cover-form"
                :cover="cover_data"
                :validation="validation"
                :renew_id="renew_id"
                @is-form-dirty="isFormDirty"
                @formSubmit="onSave"
                @update="updateCover"
                @cancel="onCoverCancel"
                :processing="processing"
                ref="CoversForm"
                section_type="renew"
            />
            <modal-covers @select="handleSelect" ref="CoversModal" section_type="renew" />
        </template>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import FormCover from '@/components/forms/Cover.vue';
import FormRenewCover from '@/components/forms/covers/Renew.vue';
import ModalCovers from '@/components/modals/Covers.vue';

export default {
    components: {
        Layout,
        FormCover,
        FormRenewCover,
        ModalCovers,
    },
    data() {
        return {
            is_fetched: false,
            data: {
                policy_number: '',
                registration_number: '',
            },
            cover_data: {
                insurer_id: '',
                company_id: '',
                policy_number: '',
                product_code: '',
                policy_start_date: null,
                policy_end_date: null,
                policy_date_range: {
                    start_date: null,
                    end_date: null,
                },
                cover_effective_date: null,
                cover_expiry_date: null,
                cover_date_range: {
                    start_date: null,
                    end_date: null,
                },
                certificate_type: '',
                cover_type: '',
                is_motor_trade: false,
                manual_certificate_number: '',
                policyholder_address: '',
                risk_mortgagee: '',
                cover_category: '',
                section_1_label: '',
                section_1: '',
                section_2_label: '',
                section_2: '',
                section_3_label: '',
                section_3: '',
                section_4_label: '',
                section_4: '',
                registration_number: '',
                chassis_number: '',
                vehicle_make: '',
                vehicle_model: '',
                vehicle_year: null,
                vehicle_color: '',
                engine_number: '',
                sum_insured: 0,
                hpcc: '',
                seating: '',
            },
            processing: false,
            form_dirty: false,
            validation: {
                errors: {},
                message: '',
            },
            renew_id: '',
        };
    },
    computed: {
        isCiaEnabled() {
            return this.$store.state.user.modules.cia;
        },
    },
    methods: {
        isFormDirty(is_dirty) {
            this.form_dirty = is_dirty;
        },
        onSave() {
            if (this.processing) {
                return false;
            }

            this.form_dirty = false;
            this.processing = true;

            let params = {
                ...this.cover_data,
                company_id: this.cover_data.insurer_id,
                intermediary_id: this.cover_data.company_id,
                policy_name_list: this.$refs.CoversForm.policy_name_list,
                cover_date_range: null,
                policy_date_range: null,
                policy_start_date: this.$dayjs(this.cover_data.policy_start_date).format('YYYY-MM-DD'),
                policy_end_date: this.$dayjs(this.cover_data.policy_end_date).format('YYYY-MM-DD'),
                cover_effective_date: this.$dayjs(this.cover_data.cover_effective_date).format('YYYY-MM-DD'),
                cover_expiry_date: this.$dayjs(this.cover_data.cover_expiry_date).format('YYYY-MM-DD'),
                policy_start_time: this.$dayjs(this.cover_data.policy_start_date).format('HH:mm:ss'),
                policy_end_time: this.$dayjs(this.cover_data.policy_end_date).format('HH:mm:ss'),
                cover_effective_time: this.$dayjs(this.cover_data.cover_effective_date).format('HH:mm:ss'),
                cover_expiry_time: this.$dayjs(this.cover_data.cover_expiry_date).format('HH:mm:ss'),
            };

            this.$http
                .post('/api/covers', params)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.form_dirty = false;
                        this.$notification.success({
                            message: response.data.message,
                        });

                        this.$router.push({
                            name: 'edit-cover',
                            params: {
                                id: response.data.cover.id,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVCA0136' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        updateCover(value) {
            this.cover_data = {
                ...this.cover_data,
                ...value,
            };
        },
        showModal() {
            this.$refs.CoversModal.showModal();
        },
        handleSelect(data) {
            this.data = data;
        },
        onCancel() {
            this.$router.go(-1);
        },
        onCoverCancel() {
            this.is_fetched = false;
            this.data = {
                policy_number: '',
            };
            this.cover_data = {
                insurer_id: '',
                company_id: '',
                policy_number: '',
                product_code: '',
                policy_start_date: null,
                policy_end_date: null,
                policy_date_range: {
                    start_date: null,
                    end_date: null,
                },
                cover_effective_date: null,
                cover_expiry_date: null,
                cover_date_range: {
                    start_date: null,
                    end_date: null,
                },
                certificate_type: '',
                cover_type: '',
                is_motor_trade: false,
                manual_certificate_number: '',
                policyholder_address: '',
                risk_mortgagee: '',
                cover_category: '',
                section_1_label: '',
                section_1: '',
                section_2_label: '',
                section_2: '',
                section_3_label: '',
                section_3: '',
                section_4_label: '',
                section_4: '',
                registration_number: '',
                chassis_number: '',
                vehicle_make: '',
                vehicle_model: '',
                vehicle_year: null,
                vehicle_color: '',
                engine_number: '',
                sum_insured: 0,
                hpcc: '',
                seating: '',
            };
        },
        onPolicySelect() {
            this.processing = true;
            this.$http
                .post('/api/covers/get-by-policy-or-registration-number', { ...this.data })
                .then((response) => {
                    if (response.data.status == 'error') {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    } else {
                        this.cover_data = {
                            ...this.cover_data,
                            ...response.data.data,
                            id: null,
                            insurer_id: response.data.data.company_id,
                            insurer_name: response.data.data.name,
                            company_id: response.data.data.intermediary_id,
                            is_motor_trade: response.data.data.is_motor_trade === 1 ? true : false,
                        };

                        let new_start_date = this.$dayjs().format('YYYY-MM-DD HH:mm:ss');
                        let new_end_date = this.$dayjs()
                            .add(1, 'years')
                            .subtract(1, 'days')
                            .endOf('day')
                            .format('YYYY-MM-DD HH:mm:ss');

                        let new_date_range = this.$dayjs();

                        if (this.$dayjs(response.data.data.policy_end_date).diff(this.$dayjs()) >= 0) {
                            new_start_date = this.$dayjs(response.data.data.policy_end_date).format(
                                'YYYY-MM-DD HH:mm:ss',
                            );

                            new_end_date = this.$dayjs(response.data.data.policy_end_date)
                                .add(1, 'years')
                                .subtract(1, 'days')
                                .format('YYYY-MM-DD HH:mm:ss');

                            new_date_range = this.$dayjs(response.data.data.policy_end_date, 'YYYY-MM-DD HH:mm:ss');
                        }

                        //Set new dates
                        this.cover_data.policy_start_date = new_start_date;
                        this.cover_data.policy_end_date = new_end_date;
                        this.cover_data.cover_effective_date = new_start_date;
                        this.cover_data.cover_expiry_date = new_end_date;

                        //Set date ranges
                        this.cover_data.policy_date_range = {
                            start_date: new_date_range,
                            end_date: new_date_range.clone().add(1, 'years').subtract(1, 'days').endOf('day'),
                        };

                        this.cover_data.cover_date_range = {
                            start_date: new_date_range,
                            end_date: new_date_range.clone().add(1, 'years').subtract(1, 'days').endOf('day'),
                        };

                        this.renew_id = response.data.data.id;

                        this.is_fetched = true;
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: response.data.message,
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
